import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/unified-sso.png")